export default {
      id: "icon--chevron-right-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "sprite.svg#icon--chevron-right",
      toString: function () {
        return this.url;
      }
    }